import { useEffect } from 'react'

export interface ISelectedBank {
    saderat: boolean
    parsian: boolean
}

interface IGateway {
    is_default: boolean
}

interface IData {
    gateways?: IGateway[]
}

export const useIsDefaultGateway = (
    data: IData | undefined,
    setIsSelected: React.Dispatch<React.SetStateAction<ISelectedBank>>
) => {
    useEffect(() => {
        if (data && data.gateways) {
            const parsianDefault = data.gateways[0]?.is_default || false
            const saderatDefault = data.gateways[1]?.is_default || false

            setIsSelected({
                parsian: parsianDefault,
                saderat: saderatDefault,
            })
        } else {
            setIsSelected({
                parsian: false,
                saderat: false,
            })
        }
    }, [data, setIsSelected])
}
